module.exports = __webpack_public_path__ + "img/img_assmat.45e5fdcb.jpg";